import { Box } from 'braid-design-system';
import type { ComponentProps } from 'react';

import { thumbnailSize } from './PictureThumbnail.css';

interface PictureThumbnailProps {
  imageSrc: string;
  imageAlt: string;
  size?: 'large' | 'standard' | 'small' | 'xsmall';
  loading?: boolean;
  thumbnailStyle?: ComponentProps<typeof Box>['className'];
}

const PictureThumbnail = ({
  imageSrc,
  imageAlt,
  size = 'standard',
  loading = false,
  thumbnailStyle,
}: PictureThumbnailProps) => {
  if (loading) {
    return (
      <Box
        className={thumbnailSize[size]}
        aria-hidden
        borderRadius="full"
        background="neutralLight"
      />
    );
  }

  return (
    <Box
      component="img"
      borderRadius="full"
      className={[thumbnailSize[size], thumbnailStyle]}
      aria-hidden
      display="flex"
      alignItems="center"
      justifyContent="center"
      src={imageSrc}
      alt={imageAlt}
    />
  );
};
export default PictureThumbnail;
